import styled from 'styled-components';
import { Vehicle } from '../../../../../types/vehicle';
import { ImageComponent } from '../ImageComponent';
import { InfoComponent } from '../InfoComponent';
import { Actions } from '../Actions';
import { MilesInfo } from '../MilesInfo';
import { useDesktopItems, useLandscapeItems } from '../MobileVehicleCard/useInfoItems';
import { BidStatus } from '../BidStatus';
import { VehiclePopover } from 'components';
import VehicleNotesPopover from 'components/VehicleNotesPopover';
import { useCurrentUser } from 'hooks/selectors';
import { useVehicleListContext } from '../../context';

const Wrapper = styled.div`
  display: flex;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  background: #fff;
  padding: 18px 16px;
  gap: 16px;
  width: 100%;
`;

const InnerWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-grow: 1;
  flex-direction: column;
`;

const DataContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  color: #000;
`;

const MainContent = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

const ActionsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const DesktopVehicleCard = ({ vehicle }: { vehicle: Vehicle }) => {
  const [leftItems, rightItems] = useDesktopItems(vehicle);

  const { localUpdate } = useVehicleListContext();

  const user = useCurrentUser();
  const showPopover = user.job_title === 'Admin';

  return (
    <Wrapper>
      <ImageComponent vehicle={vehicle} />

      <InnerWrapper>
        <TitleWrapper>
          <Title>{`${vehicle.year} ${vehicle.make} ${vehicle.model}`}</Title>
          {showPopover && <VehicleNotesPopover afterSave={localUpdate} vehicleData={vehicle} />}
        </TitleWrapper>

        <DataContainer>
          <MainContent>
            <InfoComponent size="lg" withBorder items={leftItems} />
            <InfoComponent size="lg" withBorder items={rightItems} />
          </MainContent>
          <BidStatus vehicle={vehicle} />
          <MilesInfo vehicle={vehicle} />
          <ActionsWrapper>
            <Actions vehicle={vehicle} />
          </ActionsWrapper>
        </DataContainer>
      </InnerWrapper>
    </Wrapper>
  );
};
